import { colorSet } from '@theme';

interface IFrameProps {
  width: number | string;
  margin?: string;
  padding?: string;
}

export const Frame: React.FC<React.PropsWithChildren<IFrameProps>> = ({ children, ...props }) => {
  const { width, margin = '0px', padding = '0px 40px' } = props;

  return (
    <>
      <div
        style={{
          display: 'inline-block',
          flexDirection: 'column',
          width: '100%',
          backgroundColor: colorSet.white,
          margin: margin,
          padding: padding
        }}
      >
        <div
          style={{
            margin: '0 auto',
            maxWidth: width
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};
